import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardActionArea, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import StaticPageLayout from '../components/StaticPageLayout';

const cities = [
  { id: 'addis-ababa', name: 'Addis Ababa', description: 'The capital and largest city of Ethiopia' },
  { id: 'dire-dawa', name: 'Dire Dawa', description: 'Major industrial and commercial center' },
  { id: 'mekelle', name: 'Mekelle', description: 'Northern Ethiopia\'s business hub' },
  { id: 'gondar', name: 'Gondar', description: 'Historic city with growing business sector' },
  { id: 'hawassa', name: 'Hawassa', description: 'Southern region\'s commercial center' },
  { id: 'bahir-dar', name: 'Bahir Dar', description: 'Northwestern trade and tourism hub' },
  { id: 'adama', name: 'Adama', description: 'Industrial and educational center' },
  { id: 'jimma', name: 'Jimma', description: 'Southwestern commercial hub' }
];

const Cities: React.FC = () => {
  return (
    <StaticPageLayout>
      <Helmet>
        <title>Cities | ET-Business Directory</title>
        <meta name="description" content="Find businesses in major Ethiopian cities including Addis Ababa, Dire Dawa, Mekelle, Gondar, Hawassa, Bahir Dar, and more. Browse local businesses by city." />
      </Helmet>
      
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Browse by City
        </Typography>
        
        <Typography variant="body1" paragraph>
          Explore businesses in major Ethiopian cities. Click on a city to find local businesses and services.
        </Typography>
        
        <Grid container spacing={3}>
          {cities.map((city) => (
            <Grid item xs={12} sm={6} md={4} key={city.id}>
              <Card>
                <CardActionArea component={RouterLink} to={`/city/${city.id}`}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {city.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {city.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </StaticPageLayout>
  );
};

export default Cities; 